import { render, staticRenderFns } from "./SampleFooter.vue?vue&type=template&id=6828f8cd&scoped=true"
import script from "./SampleFooter.vue?vue&type=script&lang=js"
export * from "./SampleFooter.vue?vue&type=script&lang=js"
import style0 from "./SampleFooter.vue?vue&type=style&index=0&id=6828f8cd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6828f8cd",
  null
  
)

export default component.exports